import { useMemo } from 'react';

import { RESONANCE_THEMES } from '../constants';

const useResonanceThemeOptions = () => {
  return useMemo(
    () => [
      {
        label: 'Factive',
        value: RESONANCE_THEMES.FACTIVE,
      },
      {
        label: 'Hackabu',
        value: RESONANCE_THEMES.HACKABU,
      },
    ],
    [],
  );
};

export default useResonanceThemeOptions;
